export const LOAD_EXHIBITIONS_SUCCESS = 'LOAD_EXHIBITIONS_SUCCESS';

export const LOAD_ARTWORKS_SUCCESS = 'LOAD_ARTWORKS_SUCCESS';

export const LOAD_AWARDS_SUCCESS = "LOAD_AWARDS_SUCCESS";

export const LOAD_SKETCHADAYS_SUCCESS = "LOAD_SKETCHADAYS_SUCCESS";

export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js